import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components";
import MuiTextField from '@material-ui/core/TextField';
import { KeyboardArrowDown as MuiKeyboardArrowDown, Refresh as MuiRefresh } from "@material-ui/icons";
import MuiInputAdornment from '@material-ui/core/InputAdornment';
import ClientTaskRate from "./ClientTaskRate";
import styles from "../../styles";

const TaskRow = styled.div`
  ${styles.TaskRow}
`;
const InputAdornment = styled(MuiInputAdornment)`
  ${styles.InputAdornment}
`;
const KeyboardArrowDown = styled(MuiKeyboardArrowDown)`
  ${styles.KeyboardArrowDown}
`;
const TextField = styled(MuiTextField)`
  ${styles.RateTextField}
  input { padding: ${p => p.ratePresent ? '5px 15px 5px 5px' : '5px 15px'} }
`;
const CheckboxWrapper = styled.div`
  ${styles.CheckboxWrapper}
`;
const Refresh = styled(MuiRefresh)`
  ${styles.Refresh}
`;

class TaskRates extends React.Component {
  state = {
    expanded: false,
    billable: this.props.billable,
    override: this.props.override,
    rate: this.props.rate ? parseFloat(this.props.rate).toFixed(2) : this.props.rate
  }

  toggleTasks = () => this.setState({expanded: !this.state.expanded})

  handleBillableCheckbox = () => {
    const { task, rate, handleTaskRate } = this.props;
    const billable = !this.state.billable;
    this.setState({ billable })
    handleTaskRate(task.id, rate, billable, this.state.override, true)
    if (billable) {
      setTimeout(() => {
        document.getElementById(`${task.id}_rate`).focus()
      }, 0);
    }
  }

  handleOverrideCheckbox = () => {
    const { task, rate, handleTaskRate } = this.props;
    const override = !this.state.override;
    this.setState({ override })
    handleTaskRate(task.id, rate, this.state.billable, override, true)
  }

  handleRateChange = (event) => this.setState({rate: event.target.value})

  handleResetClick = () => {
    const { task, rate, handleTaskRate } = this.props;
    const { billable, override } = this.state;

    const confirm = window.confirm("Are you sure you want to reset the rate so it inherits from it's parent?");
    if (confirm) handleTaskRate(task.id, rate, billable, override, false)
  }

  render () {
    const { toggleTasks, handleRateChange, handleBillableCheckbox, handleOverrideCheckbox, handleResetClick } = this;
    const { expanded, billable, override, rate } = this.state;
    const {
      clients,
      members,
      task,
      taskUser,
      user_rate,
      handleTaskRate,
      handleClientTaskRate,
      clientTaskUsers: allClientTaskUsers = []
    } = this.props;
    const clientTaskUsers = allClientTaskUsers.filter(clientTaskUser => clientTaskUser.task_id == task.id);
    const clientTaskType = "client";

    const ratePresent = (billable && override && rate !== null && rate !== "");

    const adornment = <InputAdornment position="start">$</InputAdornment>

    return (
      <React.Fragment>
        <TaskRow>
          <a href={`/services/${task.id}/edit`} target="blank">{task.name}</a>
          <span />
          {
            taskUser.rate_changed ?
              <Refresh onClick={handleResetClick} /> :
              <span />
          }
          <CheckboxWrapper>
            <div className="hl_checkbox">
              <input
                className="display_none"
                type="checkbox"
                name={`${task.id}_override`}
                id={`${task.id}_override`}
                checked={override}
                onChange={() => {}}
              />
              <label onClick={handleOverrideCheckbox} htmlFor={`${task.id}_override`}></label>
            </div>
          </CheckboxWrapper>
          <CheckboxWrapper>
            <div className="hl_checkbox">
              <input
                className="display_none"
                type="checkbox"
                name={`${task.id}`}
                id={`${task.id}`}
                checked={billable}
                disabled={!override}
                onChange={() => {}}
              />
              <label
                className={!override ? "checkbox_disabled" : ""}
                onClick={override ? handleBillableCheckbox : undefined}
                htmlFor={`${task.id}`}
              />
            </div>
          </CheckboxWrapper>
          <TextField
            id={`${task.id}_rate`}
            value={ratePresent ? (rate || "") : ""}
            placeholder={rate ? parseFloat(rate).toFixed(2) : ""}
            onChange={handleRateChange}
            onBlur={event => handleTaskRate(task.id, event.target.value, billable, override, true)}
            margin="normal"
            variant="filled"
            disabled={!billable || !override}
            InputProps={{
              startAdornment: ratePresent ? adornment : null,
              disableUnderline: true
            }}
            ratePresent={ratePresent}
          />
          <KeyboardArrowDown className={expanded ? "rotated": "unrotated"} onClick={toggleTasks} />
        </TaskRow>
        <div style={{borderTop: "1px solid lightgrey"}}>
          {
            (clients || []).map((client, index) => {
              const clientTaskUser = clientTaskUsers.find(ctu => ctu.client_id == client.id) || {};
              const member = members.find(m => m.client_id == client.id) || {};

              let backupRate = client.rate;
              let backupBillable = client.billable;
              let rate_changed = false
              if (member && member.rate_changed) {
                backupRate = member.rate;
                backupBillable = member.billable;
                rate_changed = true
              }
              if (task && task.override) {
                backupRate = task.rate;
                backupBillable = task.billable;
              }
              if (taskUser && taskUser.override && taskUser.rate_changed) {
                backupRate = taskUser.rate;
                backupBillable = taskUser.billable;
                rate_changed = true
              }

              if (clientTaskUser.rate_changed) rate_changed = true;
              const useClientTaskUser = clientTaskUser.rate_changed;
              let rate = useClientTaskUser ? clientTaskUser.rate : backupRate;
              let billable = useClientTaskUser ? clientTaskUser.billable : backupBillable;

              if (user_rate && !rate_changed && (!billable || !rate)) {
                billable = true
                rate = user_rate
              }

              return(
                expanded ?
                  <ClientTaskRate
                    key={`${index}_${rate}`}
                    {...{
                      client,
                      task,
                      clientTaskUser,
                      clientTaskType,
                      handleClientTaskRate,
                      rate,
                      billable
                    }}
                  /> : null
              )
            })
          }
        </div>
      </React.Fragment>
    );
  }
}

TaskRates.propTypes = {
  task: PropTypes.object,
  clientTaskUsers: PropTypes.array,
  handleTaskRate: PropTypes.func,
  handleClientTaskRate: PropTypes.func,
  rate: PropTypes.string,
};
export default TaskRates;
